import { useState, useEffect } from 'react';

const PHONE_MAX = 767;
const TABLET_MAX = 1023;

export interface ViewportState {
  isPhone: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  /** @deprecated Prefer isPhone — alias for width < 768 */
  isMobile: boolean;
  screenWidth: number;
}

/**
 * Viewport tiers: phone (<768), tablet (768–1023), desktop (≥1024).
 * Matches Tailwind `md` (768) and `lg` (1024) breakpoints.
 */
export function useViewport(): ViewportState {
  const [screenWidth, setScreenWidth] = useState<number>(
    typeof window !== 'undefined' ? window.innerWidth : 1024,
  );

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isPhone = screenWidth <= PHONE_MAX;
  const isTablet = screenWidth >= PHONE_MAX + 1 && screenWidth <= TABLET_MAX;
  const isDesktop = screenWidth > TABLET_MAX;

  return {
    isPhone,
    isTablet,
    isDesktop,
    isMobile: isPhone,
    screenWidth,
  };
}
